module.exports = __webpack_public_path__ + "img/bg.52c7a4dd.webp";